<template>
  <b-modal id="verify-email-identity-modal" ref="verifyEmailModal" hide-header hide-footer @show="beforeModalShow" @hidden="resetModalValues" :no-close-on-esc="noCloseOnBackdrop" :no-close-on-backdrop="noCloseOnBackdrop">
    <div class="auth-screen">
      <div class="">
        <div class="card">
          <div class="card-body">
            <h2 class="card-title">Verify Your Email</h2>
            <div class="card-description">
              We've sent a six-digit confirmation code to your new email address.
            </div>
            <form class="otp_form">
              <div class="form-group otp-input-group">
                <label>Enter Code</label>
                <div class="row">
                  <div class="col-lg-2">
                    <input
                      type="text"
                      v-validate="'required|digits:1'"
                      name="otp_1"
                      :class="{
                        input: true,
                        'is-danger': errors.has('otp_1'),
                        'is-success': !errors.has('otp_1')
                      }"
                      class=" form-control form-control-sm "
                      v-model="otp_1"
                      maxlength="1"
                      id="1"
                      v-on:keyup="validatePassKey(1)"
                      required
                      tabindex="-1"
                    />
                  </div>
                  <div class="col-lg-2">
                    <input
                      type="text"
                      v-validate="'required|digits:1'"
                      name="otp_2"
                      :class="{
                        input: true,
                        'is-danger': errors.has('otp_2'),
                        'is-success': !errors.has('otp_2')
                      }"
                      class="form-control form-control-sm "
                      v-model="otp_2"
                      maxlength="1"
                      id="2"
                      v-on:keyup="validatePassKey(2)"
                      required
                    />
                  </div>
                  <div class="col-lg-2">
                    <input
                      type="text"
                      v-validate="'required|digits:1'"
                      name="otp_3"
                      :class="{
                        input: true,
                        'is-danger': errors.has('otp_3'),
                        'is-success': !errors.has('otp_3')
                      }"
                      class="form-control form-control-sm  "
                      v-model="otp_3"
                      maxlength="1"
                      id="3"
                      v-on:keyup="validatePassKey(3)"
                      required
                    />
                  </div>
                  <div class="col-lg-2">
                    <input
                      type="text"
                      v-validate="'required|digits:1'"
                      name="otp_4"
                      :class="{
                        input: true,
                        'is-danger': errors.has('otp_4'),
                        'is-success': !errors.has('otp_4')
                      }"
                      class="form-control form-control-sm "
                      v-model="otp_4"
                      maxlength="1"
                      id="4"
                      v-on:keyup="validatePassKey(4)"
                      required
                    />
                  </div>
                  <div class="col-lg-2">
                    <input
                      type="text"
                      v-validate="'required|digits:1'"
                      name="otp_5"
                      :class="{
                        input: true,
                        'is-danger': errors.has('otp_5'),
                        'is-success': !errors.has('otp_5')
                      }"
                      class="form-control form-control-sm "
                      v-model="otp_5"
                      maxlength="1"
                      id="5"
                      v-on:keyup="validatePassKey(5)"
                      required
                    />
                  </div>
                  <div class="col-lg-2 mr-0">
                    <input
                      type="text"
                      v-validate="'required|digits:1'"
                      name="otp_6"
                      :class="{
                        input: true,
                        'is-danger': errors.has('otp_6'),
                        'is-success': !errors.has('otp_6')
                      }"
                      class="form-control form-control-sm "
                      v-model="otp_6"
                      maxlength="1"
                      id="6"
                      v-on:keyup="validatePassKey(6)"
                      required
                    />
                  </div>
                </div>
              </div>
              <div class="form-group">
                <div class="success-msg-style" v-if="successMsg">
                  {{ successMsg }}
                </div>
                <div class="error-style" v-if="errorMsg">{{ errorMsg }}</div>
                <div>
                  <button type="submit" class="btn btn-primary btn-block" :disabled="disableSubmitButton" v-on:click.prevent="confirmOTP">
                    Continue
                  </button>
                </div>
              </div>
              <div class="footer-links">
                <a v-on:click="resendOTP">Resend code</a>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
export default {
  name: "verifyEmailIdentity",
  data() {
    return {
      otp_1: "",
      otp_2: "",
      otp_3: "",
      otp_4: "",
      otp_5: "",
      otp_6: "",
      otp: "",
      correctOTP: false,
      successMsg: null,
      errorMsg: null,
      noCloseOnBackdrop: true,
      apiCallInProgress: false
    };
  },
  computed: {
    disableSubmitButton() {
      if (this.otp_1 == "" || this.otp_2 == "" || this.otp_3 == "" || this.otp_4 == "" || this.otp_5 == "" || this.otp_6 == "") {
        return true;
      } else if (this.errors.any()) {
        return true;
      } else if (this.apiCallInProgress) {
        return true;
      } else {
        return false;
      }
    }
  },
  props: {
    userInfo: Object
  },
  watch: {
    userInfo: {
      handler() {},
      deep: true
    }
  },
  methods: {
    resetModalValues() {
      this.otp = "";
    },
    beforeModalShow() {
      //Call api to send 6 digit otp to new email address
      this.sendOtpToMobile();
    },
    sendOtpToMobile(codeResent = false) {
      this.apiCallInProgress = true;
      this.$api
        .sendOtpToUserNewEmail({
          oldEmail: this.userInfo.oldEmail,
          newEmail: this.userInfo.newEmail,
          userId: this.userInfo.userId
        })
        .then(
          () => {
            if (codeResent) {
              this.successMsg = "Code resent";
            } else {
              this.successMsg = null;
            }
            this.apiCallInProgress = false;
            this.errorMsg = null;
          },
          error => {
            this.apiCallInProgress = false;
            this.successMsg = null;
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while sending OTP to new email address";
          }
        );
    },
    confirmOTP() {
      this.apiCallInProgress = true;
      this.otp = this.otp_1 + this.otp_2 + this.otp_3 + this.otp_4 + this.otp_5 + this.otp_6;
      this.$api
        .verifyNewEmailOtp({
          userId: this.userInfo.userId,
          otp: this.otp
        })
        .then(
          () => {
            this.apiCallInProgress = false;
            this.correctOTP = true;
            this.errorMsg = null;
            this.otp = "";
            this.otp_1 = "";
            this.otp_2 = "";
            this.otp_3 = "";
            this.otp_4 = "";
            this.otp_5 = "";
            this.otp_6 = "";
            //emit event to update profile.
            this.hide();
            this.$validator.reset();
            this.$emit("otpVerified");
          },
          error => {
            this.apiCallInProgress = false;
            this.successMsg = null;
            this.errorMsg = error.body && error.body.message ? error.body.message : "Error while confirming the OTP";
          }
        );
    },
    validatePassKey(id) {
      if (window.event.keyCode !== 8 && window.event.keyCode !== 46 && id !== 6) {
        window.document.getElementById(id + 1).focus();
      } else if ((window.event.keyCode === 8 || window.event.keyCode === 46) && id !== 1) {
        window.document.getElementById(id - 1).focus();
      }
    },
    resendOTP() {
      this.errorMsg = null;
      this.sendOtpToMobile(true);
    },
    show() {
      this.$refs.verifyEmailModal.show();
    },
    hide() {
      this.$refs.verifyEmailModal.hide();
    }
  }
};
</script>

<style lang="scss">
#verify-email-identity-modal {
  .modal-content {
    .modal-body {
      padding: 0;

      .error-style {
        font-size: 12px;
        color: #ffa500;
        padding-bottom: 15px;
        text-align: center;
      }

      .success-msg-style {
        font-size: 12px;
        color: #449d44;
        padding-bottom: 15px;
        text-align: center;
      }
    }
  }
}
</style>
<style scoped lang="scss" src="@/assets/auth-screen.scss"></style>
